import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export interface UploadSelfieRequest {
  selfie: File
  uuid: string
}

export interface UploadSelfieResponse {
  data: {
    imageUrl: string
  }
  meta: {
    message: string
    errors: string[]
  }
}

export function uploadSelfieAction(data: UploadSelfieRequest): Promise<ApiResponse<UploadSelfieResponse>> {
  const formData = new FormData()
  formData.append('selfie', data.selfie)

  return api.post<ApiResponse<UploadSelfieResponse>>(`/users/${data.uuid}/upload-identification-selfie`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
